import React, { useState, useEffect, useRef } from 'react'
import { Box } from '@elparking/components'
import { RENTAL_CAR_CLICK_TO_CALL_RECOVER_CART } from 'commons/js/constants'
import ClickToCallModal from 'rental-car-contract/js/components/Modals/ClickToCallModal'
import PropTypes from 'prop-types'
import { isOnTimeTable } from './utils'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'

export const MAX_RENTAL_CAR_PROCESS_TIME = 2 * 60000 // 2 minutes

const RentalCarProcessReminder = ({timeToWait, onActivity, isValidTimeTable}) => {
    const [showModal, setShowModal] = useState(false)
    const intervalRef = useRef(null)
    useEffect(() => {
        resetTimer()
        onActivity(resetTimer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onActivity])

    const onCloseModal = () => {
        setShowModal(false)
        resetTimer()
    }

    const resetTimer = () => {
        intervalRef.current && clearInterval(intervalRef.current)
        intervalRef.current = setInterval(() => {
            if (isValidTimeTable()) {
                setShowModal(true)
            }
        }, timeToWait)
    }
    const onModalLoad = () => {
        trackTealiumEvent(RentalCarEvents.eventC2cInactivity)
        trackTealiumEvent(RentalCarEvents.showC2cInactivity)
    }

    const handleSuccessPhoneNumberCall = () => {
        trackTealiumEvent(RentalCarEvents.showC2cInactivityPhoneSent)
        trackTealiumEvent(RentalCarEvents.eventC2cInactivityPhoneSent)
    }

    return <Box flexDirection='column' width='100%'>
        <ClickToCallModal
          isShown={showModal}
          onClose={onCloseModal}
          modalType={RENTAL_CAR_CLICK_TO_CALL_RECOVER_CART}
          onShowPrivacyModal={() => setShowModal(false)}
          zIndex={999999}
          onLoad={onModalLoad}
          onSuccessPhoneNumberCallSent={handleSuccessPhoneNumberCall}
        />
    </Box>
}

RentalCarProcessReminder.defaultProps = {
    timeToWait: MAX_RENTAL_CAR_PROCESS_TIME,
    onActivity: (resetTimer) => {
        ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach(name => {
            document.addEventListener(name, resetTimer, true)
        })
    },
    isValidTimeTable: isOnTimeTable,
}

RentalCarProcessReminder.propTypes = {
    timeToWait: PropTypes.number,
    onActivity: PropTypes.func,
    isValidTimeTable: PropTypes.func,
}

export default RentalCarProcessReminder
